<template>
	<el-header class="header" height="64px">
		<Hamburger :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />

		<el-dropdown v-if="isLogin">
			<span class="company-name">{{companyText}}</span>
			<el-dropdown-menu slot="dropdown">
				<el-dropdown-item @click.native="logout" icon="el-icon-s-tools">退出登录</el-dropdown-item>
			</el-dropdown-menu>
		</el-dropdown>
		<el-link v-else :href="$LoginUrl" class="company-name">前往登录</el-link>
	</el-header>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import Hamburger from '@/components/Hamburger'

	export default {
		data() {
			return {
				opened: true,
			}
		},
		computed: {
			...mapGetters({
				isLogin: 'token',
				sidebar: 'sidebar',
			}),
			companyText(){
				const companyName = this.$store.getters.companyName
				return companyName == null ? '加载中...' : companyName
			}
		},
		components: {
			Hamburger
		},
		methods: {
			toggleSideBar: function() {
				this.$store.dispatch('app/toggleSideBar')
			},
			logout() {
				this.$store.dispatch('user/logout')
				this.$router.push(`/home`)
			}
		}
	}
</script>

<style lang="less">
	.header {
		color: #fff;
		background-color: #4890F0;
		line-height: 64px;
		box-shadow: 0 1px 4px rgb(0 21 41 / 8%);

		.hamburger-container {
			float: left;
		}

		.el-dropdown {
			float: right;

			.company-name {
				color: #fff;
				cursor: pointer;
			}
		}

		.company-name {
			min-width: 30px;
			min-height: 36px;
			float: right;
			font-size: 14px;
			color: #fff;

			&:hover {
				color: #fff;
			}
		}
	}
</style>
